import client from "../api/client";

export const getList = () => {
  return client('/api/transactions').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/transactions/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/transactions/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/transactions', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/transactions/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useTransactionService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel
  };
}
